import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Modal from 'react-modal';
import { Header, Container, Content } from './style';
import { FindUser } from '../../FindUser';

interface IModalSearchCollaboratorsProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ModalSearchCollaborators = ({ isOpen, onClose }: IModalSearchCollaboratorsProps) => {
  return (
    <Modal
      isOpen={isOpen}
      style={{
        content: {
          maxWidth: '80vw',
          maxHeight: '70vh',
          margin: 'auto',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}>
      <Container>
        <Header>
          <h1>Encontrar Correspondentes</h1>
          <IconButton type="button" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Header>
        <Content>
          <FindUser showEmail showDescription />
        </Content>
      </Container>
    </Modal>
  );
};
